module.exports = __webpack_public_path__ + "img/appAsset--purchase-ax.a6618a3d.svg";